// reuse this anywhere, currently in herosection
// this is react scroll link by default

import styled from "styled-components";
import { Link } from "react-scroll";

export const Button = styled(Link)`
  border-radius: 50px;
  //add hover animations without using new style everythime
  background: ${({ primary }) => (primary ? "#01BF71" : "#010606")};
  white-space: nowrap;
  //if the button is big, more padding
  padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
  color: ${({ dark }) => (dark ? "#010606" : "#fff")};
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s ease-in-out;

  &:hover {
    // transition: all 0.2s ease-in-out;

    background: ${({ primary }) => (primary ? "#fff" : "#01BF71")};
  }
`;

// border-radius: 50px;
// background: #01bf71;
// white-space: nowrap;
// padding: 10px 22px;
// color: #010606;
// font-size: 16px;
// outline: none;
// border: none;
// cursor: pointer;

// transition: all 0.2s ease-in-out;
// text-decoration: none;

// &:hover {
//   transition: all 0.2s ease-in-out;
//   background: #fff;
//   color: #010606;
// }
